import { maxBreakpoints, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var responsiveText = theme.responsiveText,
  spacing = theme.spacing;
export var container = /*#__PURE__*/css(["padding:", "px 0;color:var(--neutral-white-base);", ";", ";a{display:inline-block;color:inherit;}"], spacing.sm, responsiveText.BODY.SM, mediaQuery({
  min: minBreakpoints.M
}, css(["display:grid;grid-template-columns:auto 80px;grid-template-areas:'list badge';"])));
export var awardBadge = /*#__PURE__*/css(["margin:0 auto;width:80px;", ";svg{display:block;}"], mediaQuery({
  min: minBreakpoints.M
}, css(["grid-area:badge;"])));
export var lists = /*#__PURE__*/css(["", ";"], mediaQuery({
  min: minBreakpoints.M
}, css(["grid-area:list;align-self:center;"])));
export var list = /*#__PURE__*/css(["margin:", "px 0;padding:0;list-style-type:none;display:flex;flex-wrap:wrap;column-gap:", "px;", ";"], spacing.sm, spacing.sm, mediaQuery({
  max: maxBreakpoints.S
}, css(["justify-content:center;"])));